module.exports = function toggle24Hr(groups) {
    const m = groups[groups.length - 1].toUpperCase();
    groups[groups.length - 1] = (m === 'AM') ? 'PM' : 'AM';
    return groups;
};



// WEBPACK FOOTER //
// ./src/TimeInput/lib/toggle-24-hour.js